<template>
  <div class="help w-full mt-6 box-border relative">
    <header class="pl-5 pr-4 border-l-4 border-solid border-theme text-medium-x text-theme-black-850 font-semibold">
      审批消息提醒
    </header>
    <div class="pl-6 pr-4 text-theme-black-850 text-medium">
      <!-- <div class="help-container">
        <div class="py-10 text-center">
          <div class="text-lg font-medium text-theme-black-850 mb-5">微信咨询</div>
          <img width="144" :src="qrSrc" />
          <div class="text-theme-black-650 text-sm mt-4">如您在使用上有任何问题或意见<br />请微信扫码联系客服</div>
        </div>
      </div> -->
      <!-- <p class="text-medium font-medium text-theme-black-850 leading-24">
        微信扫码关注“调研工厂+”公众号，可接收待审批和审批结果消息通知
      </p>
      <p class="text-medium font-medium text-theme-black-850 leading-24 mt-2">操作步骤</p>
      <div class="flex text-medium font-medium text-theme-black-850 leading-24 mt-2">
        <span style="font-family:ArialMT;">1、</span>
        <div>
          <p class="">
            当前账号绑定微信，如已绑定请直接进入第 2 步
          </p>
          <img class="mt-2 w-full cursor-pointer" @click="showViewer=true" src="@/assets/img/wj/binding-process2.png"/>
        </div>
      </div>
      <div class="flex text-medium font-medium text-theme-black-850 leading-24 mt-2">
        <span style="font-family:ArialMT;">2、</span>
        <div>
          <p class="">
            关注“调研工厂+”公众号
          </p>
          <img class="mt-2 w-w-22" :src="codeSrc"/>
        </div>
      </div> -->
      <!-- 未绑定微信 -->
      <template v-if="!customerUserInfo.weixinBinding">
        <div class="my-3 leading-24">绑定微信，可实时获取审核结果</div>
        <el-button style="width: 170px" type="primary" @click="personalMsgShow = true">绑定微信</el-button>
      </template>
      <!-- 已绑定微信且未关注公众号 -->
      <template v-else-if="customerUserInfo.weixinBinding && !customerUserInfo.weixinFans">
        <div class="my-3 leading-24">关注“<span v-custom="'out_D74'">调研工厂+</span>”公众号，可实时获取审核结果</div>
        <img class="w-w-22" :src="codeSrc" alt="公众号二维码" />
      </template>
      <!-- 已绑定微信且已关注公众号 -->
      <template v-else>
        <div class="my-3 leading-24">审核结果将通过“<span v-custom="'out_D74'">调研工厂+</span>”公众号推送</div>
        <img class="w-w-22" src="/assets/img/code/Mrs.Chai.png" alt="客服二维码" />
      </template>
    </div>
    <!-- 点击预览 大图 -->
    <el-image-viewer
      v-if="showViewer"
      :initialIndex="0"
      :on-close="()=>{ showViewer=false }"
      :url-list="imageUrl"
      :z-index="5000"
    />
    <!-- 个人设置组件 -->
    <PersonalMsg v-if="personalMsgShow" :personalMsgShow="personalMsgShow" @onCloseDialog="personalMsgShow = false" :openQrCode="true" />
  </div>
</template>

<script>
import ElImageViewer from 'dygc-ui/packages/image/src/image-viewer'
import { mapGetters } from 'vuex'

export default {
  components: {ElImageViewer},
  data() {
    return {
      codeSrc: process.env.VUE_APP_OFFICIAL_ACCOUNT_QR_CODE,
      imageUrl: [require('@/assets/img/wj/binding-process2.png')],
      showViewer: false,
      personalMsgShow: false
    }
  },
  computed: {
    ...mapGetters(['customerUserInfo']), // weixinBinding: 是否绑定微信；
    qrSrc() {
      return this.imgUrl ? this.imgUrl : this.baseUrl + 'img/code/Customer.Service.png'
    }
  }
}
</script>

<style lang="scss" scoped>
.help-container {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 24px;
}
</style>
